export const privacyPolicyPagePath = '/privacy-policy';